/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S12_Hours_BodyInputs */

const tr_mesafeli_s12_hours_body = /** @type {(inputs: Mesafeli_S12_Hours_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazartesi-Cuma, 09:00-18:00 (Türkiye Saati / TSİ). Hafta sonu ve resmi tatillerde destek yanıt süresi uzayabilir; kritik olaylar için 7/24 izleme yapılır.`)
};

const en_mesafeli_s12_hours_body = /** @type {(inputs: Mesafeli_S12_Hours_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday to Friday, 09:00 to 18:00 (Turkey Time / TSİ). At weekends and on public holidays the support response time may be longer; critical incidents are monitored 24/7.`)
};

const de_mesafeli_s12_hours_body = /** @type {(inputs: Mesafeli_S12_Hours_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montag bis Freitag, 09:00 bis 18:00 Uhr (türkische Zeit / TSİ). An Wochenenden und gesetzlichen Feiertagen kann sich die Reaktionszeit des Supports verlängern; kritische Vorfälle werden rund um die Uhr (7/24) überwacht.`)
};

const ru_mesafeli_s12_hours_body = /** @type {(inputs: Mesafeli_S12_Hours_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`с понедельника по пятницу, с 09:00 до 18:00 (время Турции / TSİ). В выходные и официальные праздники время ответа поддержки может увеличиваться; критические инциденты отслеживаются в режиме 7/24.`)
};

/**
* | output |
* | --- |
* | "Monday to Friday, 09:00 to 18:00 (Turkey Time / TSİ). At weekends and on public holidays the support response time may be longer; critical incidents are moni..." |
*
* @param {Mesafeli_S12_Hours_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s12_hours_body = /** @type {((inputs?: Mesafeli_S12_Hours_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S12_Hours_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s12_hours_body(inputs)
	if (locale === "de") return de_mesafeli_s12_hours_body(inputs)
	if (locale === "ru") return ru_mesafeli_s12_hours_body(inputs)
	return tr_mesafeli_s12_hours_body(inputs)
});